/**
 * Re-runs Klarna On-Site Messaging after the variant picker swaps the price partial,
 * so the "pay later" amount matches the selected variant. No-op when the Klarna embed is off.
 */
const refreshKlarna = () => {
  if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
  else if (window.KlarnaOnsiteService?.push) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
};

let queued = false;
const observer = new MutationObserver((mutations) => {
  const added = mutations.some((m) =>
    [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('klarna-placement') || n.querySelector('klarna-placement')))
  );
  if (!added || queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    refreshKlarna();
  });
});

observer.observe(document.body, { childList: true, subtree: true });
